import styled, {css, system, th} from 'quickstart/system'
import {overflowEllipsis} from 'quickstart/utils'

export const Tag = styled.div(
  ({hasAction, height, variant, width}) => css`
    ${th('tags.default')};
    ${th(`tags.variants.${variant}`)};
    display: inline-flex;
    justify-content: center;
    line-height: 1; /* avoid cropped font */
    margin-bottom: ${th('space.xxs')};
    padding: 0.625em 0.875em;
    ${overflowEllipsis}

    &:not(:last-child) {
      margin-right: ${th('space.xxs')};
    }

    ${system};
  `,
)

export const ActionIconWrapper = styled.div(
  ({size}) => css`
    display: inline-block;
    height: 1rem;
    width: 1rem;
    line-height: 1;
    margin-left: 0.625rem;
  `,
)

export const TagGroup = styled.div``
